module.exports = __webpack_public_path__ + "img/1-2.0b5b593b.png";